import i18n from '@/utils/i18n';
import { InvoiceUnpaidItemType } from '@/contexts/payments-context';
import { SubmitOrderLoyaltyEarn } from '@/types';
import { ToastOptions } from '@/components/toast';

export interface OrderSubmittedComponentProps {
  canPayInvoice?: boolean;
  completionToast?: ToastOptions;
  externalReviewRequired: boolean;
  fulfillmentDates: string[];
  isShippingOrder: boolean;
  isSplitOrder: boolean;
  loyaltyEarns: SubmitOrderLoyaltyEarn[];
  onPayNowPress?: () => void;
  reviewRequired: boolean;
  smartOrderRestaurantName?: string;
  unpaidInvoice?: InvoiceUnpaidItemType;
}

export interface AdditionalInput {
  id: string;
  title: string;
  value: string;
}

export const getPlacedOrderCopy = ({
  externalReviewRequired,
  reviewRequired,
  isSplitOrder,
  isShippingOrder,
  fulfillmentDates,
  loyaltyEarns,
  smartOrderRestaurantName,
}: OrderSubmittedComponentProps) => {
  const orderTitle = externalReviewRequired
    ? i18n.t('order_placed_action_sheet.external_review_title')
    : reviewRequired
      ? i18n.t('order_placed_action_sheet.review_title')
      : isSplitOrder
        ? i18n.t('order_placed_action_sheet.split_title')
        : smartOrderRestaurantName
          ? i18n.t('order_placed_action_sheet.smart_order_title', {
              restaurantName: smartOrderRestaurantName,
            })
          : i18n.t('order_placed_action_sheet.title');

  const fulfillmentDateString = fulfillmentDates.join(', ');

  const orderFulfillmentMessage = externalReviewRequired
    ? null
    : reviewRequired
      ? i18n.t('order_placed_action_sheet.review_message')
      : isSplitOrder
        ? i18n.t('order_placed_action_sheet.split_message', {
            fulfillmentDates: fulfillmentDateString,
          })
        : isShippingOrder
          ? null
          : i18n.t('order_placed_action_sheet.message', {
              fulfillmentDate: fulfillmentDateString,
            });

  const orderPointsEarned = loyaltyEarns
    .map((earn) =>
      earn.programs.reduce((sum, program) => sum + program.earned_points, 0),
    )
    .filter((points) => points > 0);

  const loyaltyEarnedMessage = orderPointsEarned.length
    ? i18n.t('order_placed_action_sheet.loyalty_earned', {
        points: orderPointsEarned.map((p) => p.toLocaleString()).join(', '),
      })
    : null;

  return {
    loyaltyEarnedMessage,
    orderFulfillmentMessage,
    orderTitle,
  };
};
